__webpack_require__.p = "https://cdn.tech-winnerz.com/winnerz/_next/";